import React, { useContext } from 'react';
import Typed from 'react-typed';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import bg1 from '../../assets/img/generic/01.jpg';
import dashboard from '../../assets/img/generic/bekhzod_london.jpg';

import Section from '../common/Section';
import AppContext from '../../context/Context';

const Banner = () => {
  const { isDark } = useContext(AppContext);
  return (
    <Section className="py-0 overflow-hidden" image={bg1} position="center bottom" overlay>
      <Row className="justify-content-center align-items-center pt-lg-10 pb-lg-9 pb-xl-0">
        <Col md={11} lg={8} xl={4} className="pb-7 pb-xl-9 text-center text-xl-left">
          <h1 className="text-white font-weight-light">
            Mr.
            <Typed
              strings={['Bekhzod', 'Begzod', 'Beka']}
              typeSpeed={40}
              backSpeed={50}
              className="font-weight-bold pl-2"
              loop
            />
            <br />
            Akhrorov
          </h1>
          <p className="lead text-white opacity-75">
            Full-Stack Web Developer, I speak in Javascript, Ruby, PhP, Java, C#, C, Python.
          </p>
          <a
            href="https://europa.eu/!xN33hx"
            className="btn btn-outline-light border-2x rounded-pill btn-lg mt-4 fs-0 py-2"
          >
            See more
              <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
          </a>
        </Col>
        <Col xl={{ size: 7, offset: 1 }} className="align-self-end">
          <Link to="/" className="img-landing-banner">
            <img className="img-fluid" src={dashboard} alt="" />
          </Link>
        </Col>
      </Row>
    </Section>
  );
};

export default Banner;
